export enum ProbabilityCategory {
    NA = 'N/A',
    HIGHLY_LIKELY = 'Highly Likely',
    LIKELY = 'Likely',
    POSSIBLE = 'Possible',
    LESS_LIKELY = 'Less Likely'
}